import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/GeneracInverter.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Generac Inverter and PWRCell Battery" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Inverters/Generac.js